<template>
  <div class="container">
    <headerview></headerview>
    <div class="banner" id="banner">
      <img class="banner-img" src="../assets/images/banner4.jpg" alt="">
      <img class="banner-img1" src="../assets/images/bannerm4.jpg" alt="">
      <div class="word">
        <h1><span>新闻中心</span></h1>
        <h2>NEWS CENTER</h2>
      </div>
      <div class="next-prev">
        <router-link :to="{path: '/application.html'}">
           <div class="prev">
             <img src="../assets/images/banner_jt_r.png" alt="">
             <img src="../assets/images/banner_jt_r_hover.png" alt="">
           </div>
        </router-link>
        <router-link :to="{path: '/support.html'}">
          <div class="next">
            <img src="../assets/images/banner_jt_r.png" alt="">
            <img src="../assets/images/banner_jt_r_hover.png" alt="">
          </div>
        </router-link>
      </div>
      <div class="scroll-down" @click="down"></div>
    </div>
    <nav>
      <div class="nav" id="down">
        <div :class="{'this': here[index]}" class="subnav" v-for="(item, index) in navlist">
          <router-link :to="tonav(index)">
            <span>{{item}}</span>
          </router-link>
        </div>
      </div>
    </nav>
    <div class="main" >
      <div class="title wow fadeInUp" data-wow-duration ="1s" data-wow-delay =".1s">
        <h1>{{ch.zh}}</h1>
        <span>{{ch.en}}</span>
      </div>
      <div class="mian-content" ref="miant">
        <div class="con wow fadeInUp" data-wow-duration ="1s" :data-wow-delay ="delay[index]" v-for="(item, index) in news">
          <router-link :to="topath(index)">
            <div class="time">
              <span class="day">{{day[index]}}</span>
              <span class="year">{{year[index]}}</span>
            </div>
            <div class="main-img">
              <img class="" :src="item.image" alt="">
            </div>
            <p class="msg">{{item.title}}</p>
            <div class="btn">
              <span>VIEW MORE</span>
              <img src="../assets/images/newjt.png" alt="">
            </div>
          </router-link>
        </div>
      </div>
      <div class="change">
        <div class="number">
          <span class="now">{{now}}</span>
          <span class="all">{{size}}</span>
        </div>
        <div class="m-next">
          <router-link :to="{name: 'content',params: {
              ch: this.$route.params.ch,
              page: next() + '.html'
          }}">
            <img src="../assets/images/next_page.png" alt="">
          </router-link>
        </div>
        <div class="m-prev" @click="prev">
          <router-link :to="{name: 'content',params: {
              ch: this.$route.params.ch,
              page: prev() + '.html'
          }}">
            <img src="../assets/images/prev_page.png" alt="">
          </router-link>
        </div>
      </div>
    </div>
    <footerview></footerview>
  </div>
</template>

<script>
import headerview from './public/header.vue'
import footerview from './public/footer.vue'
import 'wowjs/css/libs/animate.css'
import { option } from '../public/public.js'
import { news, channel } from '../api/index.js'
export default{
  metaInfo(){
    return {
      title: this.ch.zh + "-" + "中天亿信",
      meta: [{
        name:'viewport', content:'width=device-width, user-scalable=yes, initial-scale=1.0, maximum-scale=3.0, minimum-scale=1.0',
      },{                 // set meta
        name: 'keyWords',
        content: '中天亿信，网站建设，网站群建设，分销平台开发，网络营销推广，政务大数据，电商大数据，智慧城市，智慧政务，智慧教育，全媒体平台，云计算，企业邮箱，域名注册'
      },{                 // set meta
        name: 'description',
        content: '中天亿信是中国领先的互联网+大数据服务商，新三板上市企业、国家高新技术企业、软件企业、增值电信业务运营商，为您提供互联网平台建设、云计算、大数据以及智慧城市解决方案等服务。'
      }],
    }
  },
  components:{
    headerview,
    footerview
  },
  data(){
    return {
      s: false,
      page: 1,
      navlist: ["行业新闻","公司动态","公示公告"],
      delay: ["10s","10s","10s","10s"],
      thisTitle: "行业新闻",
      news: [],
      year: [],
      day: [],
      size: "",
      now: 1,
      si: '',
      here: [false, false, false],
      ch: {
        zh: "",
        en: ""
      }
    }
  },
  methods: {
    down(){
      option.animateScroll('banner')
    },
    tonav(index){
      if(index == 0){
        return{
          name: 'content',
          params: {
            ch: '25',
            page: '1.html'
          }
        }
      }else if(index == 1){
        return{
          name: 'content',
          params: {
            ch: '24',
            page: '1.html'
          }
        }
      }else if(index == 2){
        return{
          name: 'content',
          params: {
            ch: '26',
            page: '1.html'
          }
        }
      }
    },
    ss(){
      this.s = !this.s
    },
    topath(index){
      let id = this.news[index].id + ".html"
      let ch = this.news[index].channel.id
      return{
        name: "article",
        params: {
          id: id,
          ch: ch
        }
      }
    },
    next(){
      if(this.page < this.size){
        let page = this.page +1
        return page
      }else{
        return this.size
        console.log(this.page)
      }
    },
    prev(){
      if(this.page > 1){
        let page = this.page -1
        return page
      }else{
        return 1
      }
    }
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    new this.$wow.WOW({
      live: true
    }).init()
  },
  created() {
    if(parseInt(this.$route.params.ch) == 25){
      for(let i = 0;i<2;i++){
        this.$set(this.here, i, false)
      }
      this.ch = {
        zh: "行业新闻",
        en: "Industry News"
      }
      this.$set(this.here, 0, true)
    }else if(parseInt(this.$route.params.ch) == 24){
      for(let i = 0;i<2;i++){
        this.$set(this.here, i, false)
      }
      this.ch = {
        zh: "公司动态",
        en: "Company News"
      }
      this.$set(this.here, 1, true)
    }else if(parseInt(this.$route.params.ch) == 26){
      for(let i = 0;i<2;i++){
        this.$set(this.here, i, false)
      }
      this.ch = {
        zh: "公示公告",
        en: "Public Announcement"
      }
      this.$set(this.here, 2, true)
    }
    news({
      apikey: 123456,
      channel: parseInt(this.$route.params.ch),
      page:  parseInt(this.$route.params.page),
      pagesize: 3
    }).then(res => {
      this.news = res.data[0]
      this.size = Math.ceil(res.data.size/3)
      this.si = this.size;
      this.page = parseInt(this.$route.params.page)
      this.now = parseInt(this.$route.params.page)
      var year = []
      var day = []
      for(var i = 0; i<=2; i++){
        year.push(option.year(res.data[0][i].createtime*1000))
        day.push(option.day(res.data[0][i].createtime*1000))
        this.year = year
        this.day = day
      }
    }).catch(err => {
      console.log(err.data)
    })
  },

}
</script>

<style scoped>
.container{width: 100%; overflow-y: hidden;}
.this{background: #1f4071;}
.banner{width: 100%; position: relative; font-size: 0;}
.banner-img{width: 100%;}
.banner-img1{display: none; width: 100%;}
.word{position: absolute; width: 100%; top: 50%; transform: translateY(-50%); z-index: 1; text-align: center;}
.word span, .word img{display: inline-block; vertical-align: middle;}
.word img{margin: 0 20px 0 20px;}
.word h1{font-size: 48px; font-weight: normal; color: #ffffff;}
.word h2{font-size: 46px; font-weight: normal; color: rgba(255, 255, 255, 0.4); padding-top: 30px; text-align: center; letter-spacing: 3px;}

.prev, .next{position: absolute; display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; border-radius: 50%; font-family: "宋体"; text-align: center; cursor: pointer; top: 50%;
      z-index: 600; font-size: 36px; color: #fff; background: rgba(255, 255, 255, .1); border: 1px solid rgba(255, 255, 255, .4); transform: translateY(-50%); outline: none; transition: all .5s ease;}
  .prev:hover, .next:hover{color: #35495E; background: #fff;}
  .prev:hover::before, .next:hover::before{color: rgba(255, 255, 255, 1);}
  .prev:hover img:last-child,  .next:hover img:last-child{display: block;}
  .prev:hover img:first-child,  .next:hover img:first-child{display: none;}
  .prev{left: 100px;}
  .next{right: 100px;}
  .prev img{transform: rotate(180deg);}
  .prev img:last-child, .next img:last-child{display: none;}
  .prev::before{content: "行业应用"; font-family: "微软雅黑"; font-weight: bold; display: block; width: 100px; position: absolute; left: 60px; font-size: 18px; color: rgba(255, 255, 255, .4); transition: all .5s ease;}
  .next::before{content: "在线支持"; font-family: "微软雅黑"; font-weight: bold; position: absolute; display: block; width: 100px;  right: 60px; font-size: 18px; color: rgba(255, 255, 255, .4); transition: all .5s ease;}

nav{width: 100%; height: 81px; background-color: #1a345a;}
.nav{width: 90%; max-width: 1600px; margin: auto; display: flex;}
.subnav{position: relative; width: 33.33%; cursor: pointer; text-align: center; transition: all .5s;}
.subnav span{position: relative; font-weight: bold; color: #cbd8e7; line-height: 80px; font-size: 18px;}
.subnav span::before{content: ""; position: absolute; display: block; right: -70px; width: 30px; height: 1px; top: 50%; background: rgba(255, 255, 255, 0.3); opacity: 0; transition: all .4s;}
.subnav span::after{content: ""; position: absolute; display: block; left: -70px; width: 30px; height: 1px; top: 50%; background: rgba(255, 255, 255, 0.3); opacity: 0; transition: all .4s;}
.subnav a{display: block; width: 100%; height: 100%;}
.subnav:hover{background: #1f4071;}
.subnav:hover span::before{right: -40px; opacity: 1;}
.subnav:hover span::after{left: -40px; opacity: 1;}
.subnav::after{content: ""; position: absolute; width: 1px; height: 100%; left: 0; top: 0; background: #fff; opacity: .2;}
.subnav:last-child::before{content: ""; position: absolute; width: 1px; height: 100%; right: 0; top: 0; background: #fff; opacity: .2;}

:root{
--my-width: 100%;
--my-height: calc(var(--my-width) / 1.6)
}

.main{padding: 6.25% 0 4.1666%; background: url(../assets/images/new_09.jpg) center center; background-size: cover;}
.mian-content{width: 90%; max-width: 1600px; padding-bottom: 50px; margin: auto;}
.title{text-align: center; color: #fff; padding-bottom: 60px;}
.title h1{font-weight: normal; font-size: 36px;}
.title span{line-height: 40px; color: #c2d1e0;}
.con{width: 31.5%; display: inline-block; vertical-align: top; margin-left: 2.5%; cursor: pointer; padding: 40px; box-sizing: border-box; background: #fff;}
.con:first-child{margin-left: 0 !important;}
.main-img{position: relative; overflow: hidden; width: 100%; padding-bottom: 64%; transition: all .5s;}
.main-img img{position: absolute; width: 100%; height: 100%;}
.time{width: 100%; text-align: center; color: #666666; padding-bottom: 20px;}
.time span{display: block; font-family: myFont !important; letter-spacing: 2px }
.time .day{font-size: 36px; font-weight: normal; font-family: myFont !important; letter-spacing: 2px}
.time .day::after{content: ""; display: block; margin: auto; margin-top: 10px; margin-bottom: 10px; width: 36%; height: 1px; background: #d8d8d8;}
.msg{padding: 30px 0 30px 0; display: block; color: #5b5b5b; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
.btn{position: relative; padding: 10px; width: 100%; height: 40px; box-sizing: border-box; border: 1px solid  #c3c3c3;  color: #999; transition: all .5s ease-in-out;}
.btn::after{content: ""; position: absolute; width: 0; height: 100%; top: 0; left: 0; z-index: 1; transition: all .5s ease-in-out;  background: #0062A7;}
.con:hover .btn::after{width: 100%;}
.con:hover .time{color: #0062a7;}
.con:hover .main-img{transform: scale(1.05);}
.con:hover .btn{color: #fff;}
.btn span{position: relative; z-index: 2; float: left; font-size: 14px;}
.btn img{position: relative; z-index: 2; top: 4px; float: right;}

.change{position: relative; width: 90%; margin: auto; max-width: 1600px; height: 80px; border: 1px solid #153083; padding: 0 20px 0 20px; border-radius: 10px; line-height: 80px; text-align: center; box-sizing: border-box; color: #fff; background: #005999;}
.all{font-size: 30px;}
.all::before{content: "/"; margin-right: 10px;}
.change span{display: inline-block; padding: 0 10px 0 0px;}
.change .m-next{position: absolute; cursor: pointer; width: 100px; right: 0; top: 0;}
.change .m-next img, .change .m-prev img{-webkit-filter: grayscale(100%); filter: grayscale(100%);}
.change .m-prev{position: absolute; cursor: pointer; width: 100px; left: 0; top: 0;}

.scroll-down{width: 120px; height: 120px; cursor: pointer; position: absolute; left: 50%; bottom: 0; transform: translateX(-50%); background: url(../assets/images/scrolldown.png) no-repeat; background-size: 100% 100%;}
.scroll-down::after{content: ""; position: absolute; display: block; width: 6px; height: 6px; background: #fff; border-radius: 50%; left: 50%; top: 46px; transform: translateX(-2px); animation: scroll 1s linear  infinite;}

@keyframes scroll{
  from{top: 26px}
  to{top: 46px;}
}
@media screen and (max-width: 1200px) {
  .con{padding: 20px;}
  .msg{padding: 20px 0 20px 0;}
}
@media screen and (max-width: 1024px) and (min-width: 769px){
  .con{padding: 40px; width: 48%; margin-top: 20px;}
  .con:nth-child(odd){margin-left: 0 !important;}
  .btn{padding: 5px; font-size: 14px;}
  .msg{padding: 5px 0 5px 0; font-size: 14px;}
  .time{padding-bottom: 10px;}
  .mian-content{flex-wrap: wrap}
}
@media screen and (max-width: 768px) {
  .con{width: 100%; margin-top: 20px; margin-left: 0 !important;}
  .mian-content{flex-wrap: wrap}
  .banner-img{display: none;}
  .banner-img1{display: block;}
  .word h1, .word h2{font-size: 20px !important;}
  .next,.prev{display: none;}
}

@media screen and (min-width: 1024px) and (max-width: 1440px){
  .subnav span{font-size: 14px; line-height: 60px;}
  nav{height: 60px;}
  .subnav span::before, .subnav span::after{width: 20px;}
  .subnav:hover span::before{right: -30px;}
  .subnav:hover span::after{left: -30px;}
}
@media screen and (max-width: 1023px) {
  .nav{width: 100%;}
  .subnav{width: 100%;}
  .nav{flex-wrap: wrap;}
  nav{height: auto;}
  .subnav span{font-size: 12px; line-height: 40px;}
  .subnav:nth-child(n+2)::before{content: ""; position: absolute; width: 1px; height: 100%; right: 0; top: 0; background: #fff; opacity: .2;}
  .subnav:nth-child(-n+2){border-bottom: 1px solid rgba(255, 255, 255, .2);}
  .message-main{width: 90% !important;}
}
@media screen and (max-width: 1280px) {
    .word h1{font-size: 30px;}
    .word h2{font-size: 30px;}
    .scroll-down{width: 80px; height: 100px;}
    .scroll-down::after{width: 5px; height: 5px;}
    .prev, .next{width: 55px; height: 55px; line-height: 55px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/content.vue